import React, { useEffect } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useForm } from 'react-hook-form';

import { careerStageService } from 'services/auth';
import { getAccessToken } from 'utils/authentication';
import { getErrorText } from 'utils/geterrortext';
import SelectInputRadioButton from '@core/components/selectinputradiobutton/SelectInputRadioButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './JobForm.module.scss';

const CareerStageForm = ({ onNext, onBack, toast, type = 'account', hasName = false }) => {
    const { data, isLoading } = useQuery(
        ['career-stage', getAccessToken()],
        () => careerStageService.GET()
    );
    const { mutate } = useMutation(careerStageService.PUT, {
        onSuccess: () => {
            onNext();
        },
        onError: (err) => {
            toast(getErrorText(err), 'alert');
        }
    });

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        defaultValues: {}
    });

    useEffect(() => {
        if (data?.data) {
            reset({ career_stage: data.data.career_stage });
        }
    }, [data, reset]);

    const submitForm = (payload) => {
        mutate(payload);
    };

    const showBackButton = !(type === 'step' && hasName);

    return (
        <div className={classes.wrapper}>
            <h3>Tell Us About You</h3>
            <form onSubmit={handleSubmit(submitForm)} className="d-flex flex-column gap-3">
                <div className={classes['describe-wrapper']}>
                    <SelectInputRadioButton
                        validation={{ required: true }}
                        input={{
                            label: 'Which one best describes you?',
                            name: 'career_stage',
                            id: 'career_stage'
                        }}
                        errors={errors}
                        control={control}
                        options={data?.data?.metadata?.career_stages || []}
                        optionsIdKey='value'
                        optionsNameKey='label'
                        optionsType='array'
                        horizontal={false}
                    />
                </div>
                <div className='d-flex justify-content-center gap-5 px-md-5 px-0 mt-4'>
                    {showBackButton ? (
                        <ActionButton kind='blank' onClick={onBack}>
                            {type === 'account' ? 'Cancel' : 'Back'}
                        </ActionButton>
                    ) : (
                        <div></div>
                    )}
                    <ActionButton type="submit">
                        Next
                    </ActionButton>
                </div>
            </form>
        </div>
    );
};

export default CareerStageForm;
